import { POST } from "../../index";
export const queryTree = (param) => POST("/v1/TreeController/queryTree", param);
export const insertTree = (param) => POST("/v1/TreeController/insertTree", param);
export const updateTree = (param) => POST("/v1/TreeController/updateTree", param);
export const deleteTree = (param) => POST("/v1/TreeController/deleteTree", param);
export const queryTreeOne = (param) => POST("/v1/TreeController/queryTreeOne", param);
export const getMenuNode = (param) => POST("/v1/TreeController/getMenuNode", param);
export const getAppMenuNode = (param) => POST("/v1/TreeController/getAppMenuNode", param);
export const selectUserOrg = (param) => POST("/v1/TreeController/selectUserOrg", param);
